import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "../../../../config";
import BcValueCircle from "./BcValueCircle";

// "A/R Over 90" widget — green circle showing the total outstanding amount
// customers owe on open invoices aged over 90 days, read live from Business
// Central. Firm-wide metric (not salesperson-scoped).
const AROver90 = ({ auth: { auth }, dataScope = "all", userId })=> {
  const [value, setValue] = useState(null);

  const token = auth && auth[0] ? auth[0].token : null;
  const salesPersonId = auth && auth[0] ? auth[0]?.salesPersonId : null;
  let tmpUserId = userId;
  if(auth && (auth[0]?.roleName ==='Sales' && salesPersonId !=='')){
    tmpUserId = salesPersonId
  }
  const scopedSalesPersonId = dataScope === "self" ? tmpUserId : null;

  useEffect(() => {
    if (!token) return;
    const params = {};
    if (scopedSalesPersonId) params.salesPersonId = scopedSalesPersonId;
    axios
      .get(`${API_URL}/Dashboard/api/Dashboard/AROver90`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((res) => {
        const rows = Array.isArray(res.data)
          ? res.data
          : (res.data && res.data.result) || [];
        setValue(rows[0] ? rows[0].value : 0);
      })
      .catch((err) => {
        console.warn("Could not load A/R Over 90:", err.message);
      });
  }, [token]);

  return <BcValueCircle title="A/R Over 90" value={value} />;
};

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(AROver90);
